// Packages and components
import { deepMerge } from 'grommet/utils';
import { grommet } from 'grommet';

// Theme parts
import { animation, debounceDelay } from './globals/animation';
import { backgrounds } from './globals/backgrounds';
import { breakpoints, deviceBreakpoints } from './globals/breakpoints';
import { colors } from './globals/colors';
import { control } from './globals/control';
import { drop } from './globals/drop';
import { elevation } from './globals/elevation';
import { input } from './globals/input';
import { active, focus, hover, selected } from './globals/pseudoClasses';
import { borderSize, edgeSize, size, spacing } from './globals/sizing';
import { font } from './globals/typography';
import components from './components';

// Types
import type { ThemeType } from 'grommet';

export const GROMMET_SBOT_V2: ThemeType = deepMerge(grommet, {
  name: 'sbot-v2',
  defaultMode: 'light',
  global: {
    active,
    animation,
    backgrounds,
    borderSize,
    breakpoints: {
      ...breakpoints,
      small: {
        ...breakpoints.small,
        edgeSize,
      },
    },
    colors,
    control,
    debounceDelay,
    deviceBreakpoints,
    drop,
    edgeSize,
    elevation,
    focus,
    font,
    hover,
    input,
    selected,
    size,
    spacing,
  },
  ...components,
});

export default GROMMET_SBOT_V2;
